import { Box, CircularProgress, Stack } from "@mui/material";

import OmneByFwdIcon from "../icons/branding/OmneByFwdIcon";

const Loading = () => {
  return (
    <Stack display={"flex"} alignItems={"center"} mt={20}>
      <OmneByFwdIcon />
      <Box mt={10} data-testid="circular-progress-component">
        <CircularProgress />
      </Box>
    </Stack>
  );
};

export default Loading;
